export default {
  id: 'af016d1c0c',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=Suzuki><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a href=# class="link back"><i class="icon icon-back"></i> <span class=if-not-md>Back</span></a></div><div class=title>MoyaMoya</div></div></div><div class=page-content><div class="block block-strong no-hairlines-md margin-top-half"><p><b>Suzuki Staging:</b></p><dl><dt>Stage I</dt><dd>"Narrowing of the carotid fork" - narrowed ICA bifurcation</dd><dt>Stage II</dt><dd>"Initiation of the moyamoya"- dilated ACA, MCA and narrowed ICA bifurcation with moyamoya change</dd><dt>Stage III</dt><dd>"Intensification of the moyamoya" - further increase in moyamoya change of the ICA bifurcation and narrowed ACA and MCA</dd><dt>Stage IV</dt><dd>"Minimization of the moyamoya" - moyamoya change reducing with occlusive changes in ICA and tenuous ACA and MCA</dd><dt>Stage V</dt><dd>"Reduction of the moyamoya" - further decrease in moyamoya change with occlusion of ICA, ACA and MCA</dd><dt>Stage VI</dt><dd>"Disappearance of the moyamoya" - ICA essentially disappears with supply of brain from collaterals</dd></dl></div></div></div>';
      return r;
    }(this);
  },

  styleScoped: false
};